import React, { useState, useEffect, useRef } from "react";
import Moment from "moment";
import { connect } from "react-redux";
import { SuperInfoPause } from "../actions/websocket";
import { showmodalPause } from "../actions";
const { connection_platform } = require("../services/api");

const TimeCounterChatInternal = ({
  horario,
  status,
  max,
  iduser,
  showmodalpause,
}) => {
  const [time, setTime] = useState(!isNaN(horario) ? horario * 1000 : 0); // Estado do tempo
  const intervalRef = useRef(null); // Para armazenar o intervalo

  useEffect(() => {
    // Inicia o contador ao montar
    const startTime = Date.now() - time;

    intervalRef.current = setInterval(() => {
      setTime(Date.now() - startTime); // Atualiza o tempo
    }, connection_platform.milliseconds || 1000); // Atualiza a cada segundo

    return () => {
      // Limpa o intervalo ao desmontar
      clearInterval(intervalRef.current);
    };
  }, []); // Executa apenas uma vez ao montar

  useEffect(() => {
    // Verifica se o tempo máximo foi atingido
    if (
      max > 0 &&
      status === "Pausado" &&
      Math.round(Moment.duration(time).asSeconds()) === max
    ) {
      showmodalpause(true); // Mostra o modal
      SuperInfoPause(iduser); // Chama a função do Redux
    }
  }, [time, max, status, iduser, showmodalpause]); // Executa quando o tempo ou o status mudam

  // Formata o tempo
  const formattedTime = Moment.utc(time).format("HH:mm:ss");

  return <React.Fragment>{formattedTime}</React.Fragment>;
};

// Conexão com Redux
const mapDispatchToProps = (dispatch) => ({
  showmodalpause: (params) => dispatch(showmodalPause(params)),
});

export default connect(null, mapDispatchToProps)(TimeCounterChatInternal);
